import React from 'react';

import { BodyProps } from '@swyftx/aviary/atoms/Typography/Body/Body.styles';
import { MarginPosition } from '@swyftx/margin/build/types';

import { useMarginInstruments } from 'src/lib/margin/hooks/instruments';

import { MarginInstrument } from '../MarginInstrument';

type Props = {
  position: MarginPosition;
  size: 'small' | 'medium';
  weight?: BodyProps['weight'];
  showMarketSymbol?: boolean;
  showMarketName?: boolean;
  showFavourite?: boolean;
};

const PositionInstrument: React.FC<Props> = ({
  position,
  size,
  weight,
  showFavourite,
  showMarketName,
  showMarketSymbol,
}) => {
  const { getMarketByPosition } = useMarginInstruments();

  const market = getMarketByPosition(position);

  return (
    <MarginInstrument
      market={market}
      size={size}
      weight={weight}
      showFavourite={showFavourite}
      showMarketName={showMarketName}
      showMarketSymbol={showMarketSymbol}
    />
  );
};

export { PositionInstrument };
